import { LoiComparisonFormDto } from './models/loi-comparison-form.model';

export async function fetchLoiComparison(
    axios: { get: (url: string) => Promise<{ data: LoiComparisonFormDto[]; status: number }> },
    engagementId: number
): Promise<LoiComparisonFormDto[]> {
    const response = await axios.get(
        `/api/Marketplace/${engagementId}/LoiComparison`
    );
    if (response.status !== 200) {
        throw new Error('Failed to fetch LOI comparison');
    }
    return response.data as LoiComparisonFormDto[];
}

export async function selectAndExecuteLoi(
    axios: { post: (url: string, body: unknown) => Promise<{ status: number }> },
    engagementId: number,
    eventId: string,
    buyerId: number
): Promise<void> {
    const response = await axios.post(
        `/api/Marketplace/${engagementId}/LoiComparison/SelectAndExecute`,
        { eventId, buyerId }
    );
    if (response.status !== 200) {
        throw new Error('Failed to select and execute LOI');
    }
}

export async function setLoiResubmission(
    axios: { post: (url: string, data: unknown) => Promise<{ status: number }> },
    engagementId: number,
    buyerId: number,
    isEnabled: boolean
): Promise<void> {
    const response = await axios.post(
        `/api/Marketplace/${engagementId}/LoiComparison/Buyers/${buyerId}/Resubmission/${isEnabled}`,
        null
    );
    if (response.status !== 200) {
        throw new Error('Failed to update resubmission state');
    }
}

export async function startLoiResubmission(
    axios: { post: (url: string, data: unknown) => Promise<{ status: number }> },
    engagementId: number,
    buyerId: number
): Promise<void> {
    const response = await axios.post(
        `/api/Marketplace/${engagementId}/LoiResubmission/Buyers/${buyerId}/Start`,
        null
    );
    if (response.status !== 200 && response.status !== 204) {
        throw new Error('Failed to start LOI resubmission');
    }
}

export async function completeAdminLoiResubmission(
    axios: { post: (url: string, data: unknown) => Promise<{ status: number }> },
    engagementId: number,
    buyerId: number
): Promise<void> {
    const response = await axios.post(
        `/api/Marketplace/${engagementId}/LoiResubmission/Buyers/${buyerId}/AdminComplete`,
        null
    );
    if (response.status !== 200 && response.status !== 204) {
        throw new Error('Failed to complete admin LOI resubmission');
    }
}

export async function confirmBuyerLoiResubmission(
    axios: { post: (url: string, data: unknown) => Promise<{ status: number }> },
    engagementId: number,
    buyerId: number
): Promise<void> {
    const response = await axios.post(
        `/api/Marketplace/${engagementId}/LoiResubmission/Buyers/${buyerId}/BuyerComplete`,
        null
    );
    if (response.status !== 200 && response.status !== 204) {
        throw new Error('Failed to confirm buyer LOI resubmission');
    }
}

export async function approveLoiSelection(
    axios: { post: (url: string, body: unknown) => Promise<{ status: number }> },
    engagementId: number,
    eventId: string,
    buyerId: number
): Promise<void> {
    const response = await axios.post(
        `/api/Advisor/${engagementId}/LoiComparison/Approve`,
        { eventId, buyerId }
    );
    if (response.status !== 200 && response.status !== 204) {
        throw new Error('Failed to approve LOI selection');
    }
}

export async function declineLoiSelection(
    axios: { post: (url: string, body: unknown) => Promise<{ status: number }> },
    engagementId: number,
    eventId: string,
    buyerId: number,
    comment?: string
): Promise<void> {
    const response = await axios.post(
        `/api/Advisor/${engagementId}/LoiComparison/Decline`,
        { eventId, buyerId, comment }
    );
    if (response.status !== 200 && response.status !== 204) {
        throw new Error('Failed to decline LOI selection');
    }
}

export async function submitBuyerLoiResubmission(
    axios: { post: (url: string, data: null) => Promise<{ status: number }> },
    engagementId: number,
    buyerId: number
): Promise<void> {
    const response = await axios.post(
        `/api/Marketplace/${engagementId}/LoiResubmission/Buyers/${buyerId}/BuyerSubmit`,
        null
    );
    if (response.status !== 200 && response.status !== 204) {
        throw new Error('Failed to submit LOI resubmission');
    }
}
